import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-causes-edit',
  templateUrl: './admin-causes-edit.component.html'
})
export class AdminCausesEditComponent implements OnChanges, OnInit {
  @Input() formdata;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  

  constructor(private fb: FormBuilder) { }

ngOnInit(): void {
  this.form = this.fb.group({
    id: ['', ''],
    name: ['', ''],
    description: ['', '']
  });
}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
    }
  }

  saveCause() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }

}
